import { render, staticRenderFns } from "./EmptyBag.vue?vue&type=template&id=6b303887&scoped=true"
import script from "./EmptyBag.vue?vue&type=script&lang=js"
export * from "./EmptyBag.vue?vue&type=script&lang=js"
import style0 from "./EmptyBag.vue?vue&type=style&index=0&id=6b303887&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b303887",
  null
  
)

export default component.exports